export default __webpack_public_path__ + "static/media/Icon-open-graph.3b79cfc1.svg";